export const uk = {
    'button-cancel': 'Отмена'
};
